/**
 * Сервис для централизованного управления IntersectionObserver
 * Позволяет подписывать разные модули на события видимости DOM-элементов
 */
class VisibilityObserverService {
    constructor() {
        this.callbacks = new Map();
        this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: [0, 0.1, 0.5, 1] });
    }
    static getInstance() {
        if (!VisibilityObserverService.instance) {
            VisibilityObserverService.instance = new VisibilityObserverService();
        }
        return VisibilityObserverService.instance;
    }
    observe(element, callback) {
        this.callbacks.set(element, callback);
        this.observer.observe(element);
    }
    unobserve(element) {
        this.callbacks.delete(element);
        this.observer.unobserve(element);
    }
    handleIntersect(entries) {
        for (const entry of entries) {
            const cb = this.callbacks.get(entry.target);
            if (cb)
                cb(entry);
        }
    }
}
export default VisibilityObserverService;
